var map = {
	"./facebook-logo-white.svg": "37c1",
	"./google-logo-white.svg": "cdc1",
	"./linkedin-logo-white.svg": "9072",
	"./snapchat-logo-white.svg": "35e7",
	"./tiktok-logo-white.svg": "c239",
	"./twitter-logo-white.svg": "ae10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3fb6";